import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowExit = () => {
  return (
    <g>
      <path d="M5.999 2a.75.75 0 0 1 .102 1.493l-.102.007H2.501v8.998H6a.75.75 0 0 1 .744.649l.007.101a.75.75 0 0 1-.65.744L6 13.998H2.051c-.542 0-.988-.41-1.045-.935L1 12.948V3.05c0-.541.41-.987.937-1.044L2.05 2H6zm4.45 1.15.084.073 4.248 4.247a.75.75 0 0 1 .072.976l-.072.084-4.25 4.25a.75.75 0 0 1-1.134-.976l.072-.084 2.969-2.97H4.749a.75.75 0 0 1-.101-1.493l.101-.007h7.691L9.473 4.283a.75.75 0 0 1-.073-.976l.073-.084a.75.75 0 0 1 .976-.073z" />
    </g>
  );
};

export default withIcon(IconArrowExit);
